import React from 'react';
import { motion } from 'framer-motion';

interface PremiumCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  index?: number;
}

const PremiumCard: React.FC<PremiumCardProps> = ({ icon, title, description, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.4, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className="group ui-card ui-card-lift p-5 sm:p-6"
    >
      <div className="w-10 h-10 rounded-lg border border-line bg-canvas-muted flex items-center justify-center text-ink-secondary mb-4">
        {icon}
      </div>
      <h3 className="text-[15px] sm:text-base font-semibold text-ink mb-2 tracking-[-0.01em]">
        {title}
      </h3>
      <p className="text-sm text-ink-muted leading-relaxed">{description}</p>
    </motion.div>
  );
};

export default PremiumCard;
